import React from "react";
import Email from "@material-ui/icons/Email";
import User from "@material-ui/icons/Person";
import Message from "@material-ui/icons/Message";

class ContactUs extends React.Component {
  state = {
    status: "",
    fullName: "",
    email: "",
    msg: "",
  };
  handleChange = (event) => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  };
  submitForm = (ev) => {
    ev.preventDefault();
    const form = ev.target;
    const data = new FormData(form);
    const xhr = new XMLHttpRequest();
    xhr.open(form.method, form.action);
    xhr.setRequestHeader("Accept", "application/json");
    xhr.onreadystatechange = () => {
      if (xhr.readyState !== XMLHttpRequest.DONE) return;
      if (xhr.status === 200) {
        form.reset();
        this.setState({ status: "SUCCESS", fullName: "", email: "", msg: "" });
      } else {
        this.setState({ status: "ERROR" });
      }
    };

    xhr.send(data);
  };
  render() {
    return (
      <div className=" md:flex md:justify-center lg:pt-20 md:mt-10 md:mb-10 signin-bg ">
        <div className="w-full bg-white lg:bg-transparent md:flex md:justify-center ">
          <div
            className="flex-col justify-center items-center lg:px-16 px-8 md:px-12 xl:px-20 sign-back flex-initial md:w-1/2 md:border-2 
          md:rounded-lg"
          >
            <form
              onSubmit={this.submitForm}
              action="https://formspree.io/mvobewwy"
              method="POST"
              formdata={this.state}
            >
              <div className="flex justify-end text-xl pb-8 md:block md:flex md:justify-end text-gray-800 mt-8">
                <p className="text-2xl pt-4  pr-6">تواصل معنا</p>
              </div>
              <label className="flex justify-end mt-4 mb-2 items-center text-gray-800 md:text-sm ">
                <div className="flex items-center">
                  الاسم
                <User className=" ml-2 mr-1" color="primary" />
                </div>
              </label>
              <div className="flex justify-end mb-6 ">
                <input
                  type="text"
                  name="fullName"
                  onChange={this.handleChange}
                  value={this.state.fullName}
                  className="w-full border-2 rounded-lg px-4 py-1 focus:outline-none text-black text-right"
                />
              </div>

              <label className="flex justify-end mt-4 mb-2  items-center text-gray-800 md:text-sm ">
                <div className="flex items-center"> البريد
                <Email
                    className=" ml-2 mr-1"
                    color="primary"
                    fontSize="small"
                  />
                </div>
              </label>
              <div className="flex justify-end mb-6  ">
                <input
                  type="text"
                  name="email"
                  value={this.state.email}
                  onChange={this.handleChange}
                  className=" w-full border-2 rounded-lg px-4 py-1 focus:outline-none text-black text-right"
                />
              </div>
              <label className="flex justify-end mt-4 mb-2  items-center text-gray-800 md:text-sm ">
                <div className="flex items-center">الرساله
                <Message className=" ml-2 mr-1" color="primary" />

                </div>
              </label>
              <div className="flex justify-end pb-2  ">
                <textarea
                  name="msg"
                  value={this.state.msg}
                  onChange={this.handleChange}
                  className="border-2 rounded-lg focus:outline-none text-black text-right p-2 w-full"
                  rows="5"
                  cols="50"
                ></textarea>
              </div>

              <div className="flex justify-center md:pb-8 pt-4 pb-6">
                <div className="flex flex-col justify-center">
                  {this.state.status === "SUCCESS" ? (
                    <p className="self-center  ">تم الارسال بنجاح</p>
                  ) : (
                      <button
                        type="submit"
                        className="blue-bg border text-white rounded-lg p-2 w-40 focus:outline-none mb-8"
                      >
                        ارسال
                      </button>
                    )}
                  {this.state.status === "ERROR" && (
                    <p className="self-center ">!حصل خطأ ما </p>
                  )}
                </div>

              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}
export default ContactUs;
